// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect, useState } from "react";
import Compressor from "compressorjs";
import { Form, Upload } from "antd";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import {
  beforeUpload,
  getBase64,
  getBase64UrlFrom
} from "../../../../utils/ImageUtils";
import { NewsImageProps } from "../../../types/NewsTypes";
import { formItemBlockLayout } from "../../../../utils/Constant";
import { useTranslation } from "react-i18next";
import { displayError } from "../../../../utils/displayError";

const NewsImageForm: React.FunctionComponent<NewsImageProps> = (
  props: NewsImageProps
) => {
  const {
    inputIndex,
    onChangeCallBack,
    formFieldLabel,
    formFieldName,
    base64Url,
    editMode,
    rules,
    inputProperties,
    setImage
  } = props;

  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  const [imageUrl, setImageUrl] = useState<string | undefined>();

  const uploadButton = (
    <div className="ant-upload-button">
      {loading ? <LoadingOutlined /> : <UploadOutlined />}
      <div className="ant-upload-text">Importer</div>
    </div>
  );
  const handleSetImage = (file: File | Blob, fileName: string) => {
    getBase64(file, (imageBase64Data: any) => {
      const imageBase64Url = getBase64UrlFrom(imageBase64Data, file.type);
      setLoading(false);
      setImageUrl(imageBase64Url);
      if (onChangeCallBack && inputIndex !== undefined) {
        onChangeCallBack(imageBase64Url, file.type, inputIndex);
      }
      if (setImage) {
        setImage({
          base64Data: imageBase64Data,
          type: file.type,
          name: fileName
        });
      }
    });
  };
  const handleCompressedUpload = (image: File | Blob, fileName: string) => {
    new Compressor(image, {
      maxWidth: rules?.width,
      maxHeight: rules?.height,
      success: (file: File | Blob) => {
        handleSetImage(file, fileName);
      }
    });
  };

  const handleChange = (info: any) => {
    setLoading(true);
    if (info.file.originFileObj) {
      if (
        inputProperties?.maxWeight !== undefined &&
        inputProperties.maxWeight < info.file.size
      ) {
        displayError(
          t("global.error.image_too_heavy", {
            maxWeight: Math.floor(inputProperties.maxWeight / 1024)
          }),
          false
        );
        return;
      }
      if (rules?.height || rules?.width) {
        handleCompressedUpload(info.file.originFileObj, info.file.name);
      } else {
        handleSetImage(info.file.originFileObj, info.file.name);
      }
    }
  };

  useEffect(() => {
    if (base64Url) {
      setImageUrl(base64Url);
    }
  }, [base64Url]);

  return (
    <Form.Item
      {...formItemBlockLayout}
      name={formFieldName}
      label={<span>{formFieldLabel}</span>}
      rules={
        base64Url
          ? []
          : [
              {
                required: true,
                message: t("global.empty_error_field")
              }
            ]
      }
    >
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={file => {
          return beforeUpload(file, rules);
        }}
        onChange={handleChange}
        customRequest={() => {
          return;
        }}
        disabled={!editMode}
      >
        {imageUrl ? (
          <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
        ) : (
          uploadButton
        )}
      </Upload>
    </Form.Item>
  );
};

NewsImageForm.defaultProps = {
  editMode: true
};

export default NewsImageForm;
